import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Media from 'react-media';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import Overlay from 'components/Core/Overlay';
import IconSvg from 'components/Core/IconSvg';

import GLOBAL_MEDIA_QUERIES from 'constants/Screen';
import { NewsCard as NewsCardElem, NewsCardFigure as NewsCardFigureElem } from './NewsCard.styles';

const NewsCard = ({ shortTitle, introduction, image, url, standalone, onClick }) => {
  return (
    <Link href="/[...slug]" as={url} passHref>
      <NewsCardElem
        className={`flex flex-col justify-between h-full group ${standalone &&
          'rounded-base overflow-hidden bg-basic-200'}`}
        onClick={onClick}
      >
        <div>
          <NewsCardFigureElem className={`relative ${!standalone && 'rounded-lg overflow-hidden'}`}>
            <Overlay alwaysOn />
            <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ sm: true }}>
              {(matches) =>
                matches.xs || matches.sm ? (
                  <LazyLoadImage
                    src={image.sm.url}
                    alt={image.title}
                    className="h-full w-full object-cover object-center"
                  />
                ) : (
                  <LazyLoadImage
                    src={image.lg.url}
                    alt={image.title}
                    className="h-full w-full object-cover object-center"
                  />
                )
              }
            </Media>
            <h3 className="absolute bottom-0 pl-4 pb-4 lg:pl-8 lg:pb-6 text-white">{shortTitle}</h3>
          </NewsCardFigureElem>

          <div className={`${standalone ? 'my-6 px-4' : 'mt-5 md:mt-8'}`}>{introduction}</div>
        </div>
        <div className={`flex items-center ${standalone ? 'px-4 mt-6 mb-4' : 'mt-6 mb-10 md:my-10'}`}>
          <IconSvg icon="arrow-right" size={10} className="text-primary" />
          <div className="font-bold ml-2 group-hover:ml-1 transition-spacing duration-150 ease-in-out">lees meer</div>
        </div>
      </NewsCardElem>
    </Link>
  );
};

NewsCard.propTypes = {
  shortTitle: PropTypes.string.isRequired,
  introduction: PropTypes.string.isRequired,
  image: PropTypes.shape({
    sm: PropTypes.shape(),
    lg: PropTypes.shape(),
    title: PropTypes.string,
  }).isRequired,
  url: PropTypes.string.isRequired,
  standalone: PropTypes.bool,
  onClick: PropTypes.func,
};

NewsCard.defaultProps = {
  standalone: false,
  onClick: () => {},
};

export default NewsCard;
